var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10848_15210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00098 1.33398C10.4047 1.33416 13.167 4.09723 13.167 7.50098C13.1668 10.9046 10.4046 13.6668 7.00098 13.667C3.59723 13.667 0.83416 10.9047 0.833984 7.50098C0.833984 4.09712 3.59712 1.33398 7.00098 1.33398Z",
    fill: "#009D8A",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66763 8.94703L9.58763 5.02703C9.84763 4.76703 10.2743 4.76703 10.5343 5.02703C10.7943 5.28703 10.7943 5.70703 10.5343 5.96703L6.14096 10.3604C5.88096 10.6204 5.46096 10.6204 5.20096 10.3604L3.4743 8.6337C3.2143 8.3737 3.2143 7.9537 3.4743 7.6937C3.7343 7.4337 4.1543 7.4337 4.4143 7.6937L5.66763 8.94703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10848_15210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleOutline);
export default __webpack_public_path__ + "static/media/check_circle_outline.a1e9a0ab3aba740202a2999cad0d3067.svg";
export { ForwardRef as ReactComponent };